import React from 'react'
import {styles} from '../patient/styles/PatientPage.style'
import {styles as aboutStyles} from './styles/AboutUs.styles'
import {i18n} from '../../i18n'
import {CEImage, HerstellerBlack, HerstellerWhite, IImage, IeIFUImage, SNImage, MDImage, WarningImage} from '../../assets'
import {Image} from 'antd'
import {format} from 'date-fns'
import appConfig from '../../custom/config.json'
import {TitleText} from '../common'
import { Typography } from "antd";
import packageJson from '../../../package.json';
const { Text } = Typography;
const appVersion = packageJson.version;
const productionDate = packageJson.productionDate;

/**
 * The screen displays general information about the product provider as well as information regarding the current running version of the application
 * In this page the patient is also provided a means of contact.
 */
const AboutUs: React.FC = () => {
    return (
        <div style={styles.pageWrapper}>
            <TitleText text={i18n.t('about.title')}></TitleText>
            <p>{i18n.t('about.paragraph1')}</p>
            <p>{i18n.t('about.paragraph2')}</p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph3.subParagraph1')}
            </p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph3.subParagraph2')}
            </p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph3.subParagraph3')}
            </p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph3.subParagraph4')}
            </p>
            <p>{i18n.t('about.paragraph4')}</p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph5.subParagraph1')}
            </p>
            <p style={{paddingLeft: '3%'}}>
                <span style={aboutStyles.subParagraph}>{'-'}</span>
                {i18n.t('about.paragraph5.subParagraph2')}
            </p>
            <p>{i18n.t('about.paragraph6')}</p>
            <p>{i18n.t('about.paragraph7')}
  <div style={{ margin: '1rem 0' }}>
    <Text strong>Servicezeiten:</Text><br />
    <Text>Montag bis Freitag (außer feiertags)</Text><br />
    <Text>8:00 – 16:00 Uhr</Text><br /><br />

    <Text strong>Telefon:</Text><br />
    <Text>
      <a href="tel:49364162840284">03641/62840284</a>
    </Text><br /><br />

    <Text strong>E-Mail:</Text><br />
    <Text>
      <a href="mailto:hilfe@apat-dtb.de">
      hilfe@apat-dtb.de
      </a>
    </Text>
  </div>
  <div style={{ margin: '1rem 0' }}>
    <Text strong>Gebrauchsanweisung:</Text><br />
    <p>{i18n.t('about.paragraph8')}</p>
    <p style={{paddingLeft: '3%'}}>
        <span style={aboutStyles.subParagraph}>{'-'}</span>
        Gebrauchsanweisung für medizinisches Personal {" "}
        <a href="https://dia42.de/apat/app/manual_med.pdf" target="_blank" rel="noopener noreferrer">
            Download als PDF
        </a>
    </p>
    <p style={{paddingLeft: '3%'}}>
        <span style={aboutStyles.subParagraph}>{'-'}</span>
        Gebrauchsanweisung für Patienten {" "}
        <a href="https://dia42.de/apat/app/manual_user.pdf" target="_blank" rel="noopener noreferrer">
            Download als PDF
        </a>
    </p>
  </div>  
</p>


<table>
                {/* {appConfig.medicalDevice && (
                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={CEImage} preview={false} style={aboutStyles.image} />
                    </td>
                </tr>
                )} */}

                {appConfig.medicalDevice && (
               <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={MDImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.medicalDeviceText')}</span>
                        </div>
                    </td>
                </tr>
                )}

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={CEImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Title}>
                            <span>{i18n.t('about.info.ceTitle')}</span>
                        </div>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.ceText')}</span>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={SNImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.appVersion', { version: appVersion })}</span>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={HerstellerBlack} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.contact.part1')}</span>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={HerstellerWhite} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Content}>
                            <span>
                                {i18n.t('about.info.productionDate', {buildDate: productionDate })}
                            </span>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={IImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Title}>
                            <span>{i18n.t('about.info.noteManual')}</span>
                        </div>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.noteManualText')}</span>
                            <br/>
                            <p>
                            Gebrauchsanweisung für medizinisches Personal {" "}
                                <a href="https://dia42.de/apat/app/manual_med.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                            <p>
                                Gebrauchsanweisung für Patienten {" "}
                                <a href="https://dia42.de/apat/app/manual_user.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={IeIFUImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Title}>
                            <span>{i18n.t('about.info.noteManualEifu')}</span>
                        </div>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.noteManualEifuText')}</span>
                            <br/>
                            <p>
                            Gebrauchsanweisung für medizinisches Personal {" "}
                                <a href="https://dia42.de/apat/app/manual_med.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                            <p>
                                Gebrauchsanweisung für Patienten {" "}
                                <a href="https://dia42.de/apat/app/manual_user.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                        </div>
                    </td>
                </tr>

                <tr style={aboutStyles.row}>
                    <td style={aboutStyles.column1}>
                        <Image src={WarningImage} preview={false} style={aboutStyles.image} />
                    </td>
                    <td style={aboutStyles.column2}>
                        <div style={aboutStyles.column2Title}>
                            <span>{i18n.t('about.info.warningManual')}</span>
                        </div>
                        <div style={aboutStyles.column2Content}>
                            <span>{i18n.t('about.info.warningManualText')}</span>
                            <br/>
                            <p>
                            Gebrauchsanweisung für medizinisches Personal {" "}
                                <a href="https://dia42.de/apat/app/manual_med.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                            <p>
                                Gebrauchsanweisung für Patienten {" "}
                                <a href="https://dia42.de/apat/app/manual_user.pdf" target="_blank" rel="noopener noreferrer">
                                    Download als PDF
                                </a>
                            </p>
                        </div>
                    </td>
                </tr>

            </table>


        </div>
    )
}

export default AboutUs
